<script>
    import journeyBrickEndpointUuidMixin from '../../Mixins/journey-brick-endpoint-uuid'

    export default {
        name: 'journey-builder-composer-connection-manager',
        mixins: [journeyBrickEndpointUuidMixin],
        render(createElement, context) {
            const vm = this;
            
            //ScopedSlots allow passing in props
            return vm.$scopedSlots.default({
                connectNewCircleBricks: vm.connectNewCircleBricks
            });
        },
        created() {
            const vm = this;
            
            vm.bindGlobalEvent('connection', vm.handleNewConnection);
        },
        beforeDestroy() {
            const vm = this;
            
            Object.values(vm.managedEvents).forEach(
                eventCollection => eventCollection.forEach(event => vm.jsPlumbInstance.unbind(event))
            )
        },
        methods: {
            handleNewConnection(connectionInfo, browserEvent){
                const vm = this;
                
                //Creating a connection ourselves also triggers a connected event;
                //this event doesn't come with a browser event however
                //connections created ourselves should be left as is
                if(browserEvent == null){
                    return;
                }

                const {
                    fromToId: sourceBrickId, 
                    connectionId
                } = vm.deconstructEndpointUuid(connectionInfo.sourceEndpoint.getUuid());
                
                const {
                    fromToId: destinationBrickId 
                } = vm.deconstructEndpointUuid(connectionInfo.targetEndpoint.getUuid());

                //jsPlumb seems to break when severConnection is invoked immediately
                //thus we should wait for our next tick prior to invocation
                vm.$nextTick(() => {
                    //Our actual connection will be between our brick -> circle brick -> brick
                    //where the circle brick is created based on existing source brick connection info
                    vm.jsPlumbInstance.deleteConnection(connectionInfo.connection);

                    vm.$emit('connection-created', {
                        connectionId: connectionId,
                        sourceBrickId: sourceBrickId,
                        destinationBrickId: destinationBrickId
                    });
                });
            },
            connectNewCircleBricks(newEndpointCount, connection){
                const vm = this;

                //Nothing changed; endpoints are expected to already be connected
                if(newEndpointCount === 0) {
                    return;
                }

                vm.$nextTick(() => {
                    vm.jsPlumbInstance.batch(() => {
                        vm.jsPlumbInstance.connect({ 
                            uuids: [
                                vm.getBrickEndpointUuid(connection.id, connection.sourceBrickId),
                                vm.getCircleEndpointUuid(connection.id, connection.destinationBrickId)
                            ] 
                        });

                        vm.jsPlumbInstance.connect({ 
                            uuids: [
                                vm.getCircleEndpointUuid(connection.id, connection.sourceBrickId), 
                                vm.getBrickEndpointUuid(connection.id, connection.destinationBrickId)
                            ] 
                        });
                    });
                });
            },
            bindGlobalEvent(eventName, handler){
                const vm = this;

                vm.jsPlumbInstance.bind(eventName, handler);
                
                if(!vm.managedEvents[eventName]){
                    vm.managedEvents[eventName] = [];
                }

                vm.managedEvents[eventName].push(handler);
            }
        },
        data: () => ({
            managedEvents: {}
        }),
        props: {
            jsPlumbInstance: {
                type: Object,
                required: true
            }
        }
    }
</script>